import SpriteSymbol from "../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-undone",
  "use": "icon-undone-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-undone\"><path d=\"M64 .5C28.928.5.5 28.928.5 64s28.427 63.499 63.5 63.499S127.499 99.072 127.499 64 99.072.5 64 .5zm31.419 72.636H60.032V28.944c0-2.191 1.774-3.968 3.968-3.968s3.968 1.777 3.968 3.968v36.253h27.451a3.97 3.97 0 1 1 0 7.939z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol